import { Component, EventEmitter, OnInit, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem, ConfirmDialog, ConfirmationService, SplitButton, MenuItem} from 'primeng/primeng';
import {UIChart} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import {RequestActionGridComponent} from '../../components/Grids/RequestActionGrid.component';

@Component({
  selector: 'my-requesthistory',
  templateUrl: './RequestHistory.component.html'
})
export class RequestHistoryComponent implements OnInit {

    @ViewChild(RequestActionGridComponent) requestActionGridComponent: RequestActionGridComponent;

    userInfo: ent.UserInfo;

    options: any;


    constructor(private authenticationService: serv.AuthenticationService, private requestService: serv.RequestService, private router: Router) 
    {
        
        
    }

    ngOnInit(): void {

        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
        

    }

    ngAfterViewInit(){
       

    }

    
}